import { DatePipeConfig } from '@angular/common';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Observable, Subject, timer, of, map, takeUntil, takeWhile, EMPTY, finalize } from 'rxjs';
import { changeTimeZone } from '../functions/change-timezone.func';
import { getCurrentCentralEuropeDate } from '../functions/get-current-central-europe-date.func';

@Pipe({
    name: 'countDown',
    standalone: false
})
export class CountDownPipe implements PipeTransform {

  /**
   *
   */
  constructor(@Inject(DATE_PIPE_DEFAULT_OPTIONS) private readonly config: DatePipeConfig) {

  }

  transform(value: Date | null | undefined, parentComponentDestroyed$: Subject<void> | undefined = undefined): Observable<number> {

    if (!value) return EMPTY

    //changeTimeZone(value, this.config.timezone)

    let poller$ = timer(0, 1 * 1000).pipe(
      takeWhile(() => value > new Date()),
      map(() => this.getRemainingTime(value))
    );

    if (parentComponentDestroyed$) poller$ = poller$.pipe(takeUntil(parentComponentDestroyed$))

    return poller$
  }

  private getRemainingTime(arrivalDate: Date): number {

    const remainingTime = new Date(arrivalDate.getTime() - getCurrentCentralEuropeDate().getTime()).getTime()
    if (remainingTime < 2000) return 0
    return remainingTime
  }

}
